<template>
    <ul class="social-links">
        <li v-if="vk" class="social-links-item">
            <VkIcon
                alt="vkontakte"
                class="social-links__icon social-links__icon_vk"
                :class="{
                    'social-links__button_white-blue': whiteBlueStyle,
                    'social-links__button_contacts-card': contactsCard,
                }"
                @click="click('vk')"
            />
        </li>
        <li v-if="ok" class="social-links-item">
            <OkIcon
                alt="odnoklassniki"
                class="social-links__icon social-links__icon_ok"
                :class="{
                    'social-links__button_white-blue': whiteBlueStyle,
                    'social-links__button_contacts-card': contactsCard,
                }"
                @click="click('ok')"
            />
        </li>
        <li v-if="youtube" class="social-links-item">
            <YoutubeIcon
                alt="youtube"
                class="social-links__icon social-links__icon_yt"
                :class="{
                    'social-links__button_white-blue': whiteBlueStyle,
                    'social-links__button_contacts-card': contactsCard,
                }"
                @click="click('youtube')"
            />
        </li>
        <li v-if="rutube" class="social-links-item">
            <RutubeIcon
                alt="rutube"
                class="social-links__icon social-links__icon_rt"
                @click="click('rutube')"
                :class="{
                    'social-links__button_white-blue': whiteBlueStyle,
                    'social-links__button_contacts-card': contactsCard,
                }"
                :size="size"
            />
        </li>
        <li v-if="tg" class="social-links-item">
            <TelegramIcon
                alt="telegram"
                class="social-links__icon social-links__icon_tg"
                :class="{
                    'social-links__button_white-blue': whiteBlueStyle,
                    'social-links__button_contacts-card': contactsCard,
                }"
                @click="click('tg')"
            />
        </li>
        <li v-if="inst" class="social-links-item">
            <IntagramIcon
                alt="instagram"
                class="social-links__icon social-links__icon_inst"
                :class="{
                    'social-links__button_white-blue': whiteBlueStyle,
                    'social-links__button_contacts-card': contactsCard,
                }"
                @click="click('inst')"
            />
        </li>
        <li v-if="dzen" class="social-links-item">
            <DzenIcon
                alt="dzen"
                class="social-links__icon social-links__icon_dzen"
                @click="click('dzen')"
                :class="{
                    'social-links__button_white-blue': whiteBlueStyle,
                    'social-links__button_contacts-card': contactsCard,
                }"
                :size="size"
            />
        </li>
        <li v-if="yappy" class="social-links-item">
            <YappyIcon
                alt="yappy"
                class="social-links__icon social-links__icon_yappy"
                @click="click('yappy')"
                :class="{
                    'social-links__button_white-blue': whiteBlueStyle,
                    'social-links__button_contacts-card': contactsCard,
                }"
                :size="size"
            />
        </li>
        <li v-if="tenchat" class="social-links-item">
            <TChatIcon
                alt="tenchat"
                class="social-links__icon social-links__icon_tenchat"
                @click="click('tenchat')"
                :class="{
                    'social-links__button_white-blue': whiteBlueStyle,
                    'social-links__button_contacts-card': contactsCard,
                }"
                :size="size"
            />
        </li>
        <li v-if="copyLink" class="social-links-item">
            <LinkIcon
                alt="share"
                class="social-links__icon social-links__icon_share"
                @click="click('link')"
                :class="{
                    'social-links__button_white-blue': whiteBlueStyle,
                    'social-links__button_contacts-card': contactsCard,
                }"
                :size="size"
            />
        </li>

        <div class="bubble-wrapper" v-if="copyLink">
            <transition name="fade">
                <div v-if="copyLinkStatus.shown" class="bubble">
                    <span v-if="copyLinkStatus.success">Ссылка скопирована</span>
                    <input ref="copyLinkInput" v-else type="text" :value="copyLink" readonly />
                </div>
            </transition>
        </div>
    </ul>
</template>

<script>
import YappyIcon from '@/assets/images/icons/yappy.svg?inline';
import DzenIcon from '@/assets/images/icons/dzen.svg?inline';
import RutubeIcon from '@/assets/images/icons/rutube.svg?inline';
import YoutubeIcon from '@/assets/images/icons/youtube.svg?inline';
import TelegramIcon from '@/assets/images/icons/telegram.svg?inline';
import IntagramIcon from '@/assets/images/icons/instagram.svg?inline';
import OkIcon from '@/assets/images/icons/ok.svg?inline';
import VkIcon from '@/assets/images/icons/vk.svg?inline';
import LinkIcon from '@/assets/images/icons/link.svg?inline';
import TChatIcon from '@/assets/images/icons/tenchat.svg?inline';

export default {
    components: {
        YappyIcon,
        DzenIcon,
        RutubeIcon,
        YoutubeIcon,
        TelegramIcon,
        IntagramIcon,
        OkIcon,
        VkIcon,
        LinkIcon,
        TChatIcon,
    },

    props: {
        mode: {
            type: String,
            default: 'link',
        },
        vk: {
            type: Boolean,
            default: false,
        },
        ok: {
            type: Boolean,
            default: false,
        },
        tg: {
            type: Boolean,
            default: false,
        },
        fb: {
            type: Boolean,
            default: false,
        },
        inst: {
            type: Boolean,
            default: false,
        },
        youtube: {
            type: Boolean,
            default: false,
        },
        rutube: {
            type: Boolean,
            default: false,
        },
        yappy: {
            type: Boolean,
            default: false,
        },
        tenchat: {
            type: Boolean,
            default: false,
        },
        dzen: {
            type: Boolean,
            default: false,
        },
        copyLink: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'normal',
        },
        whiteBlueStyle: {
            type: Boolean,
            default: false,
        },
        contactsCard: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        links: {
            vk: 'https://vk.com/rsvru',
            ok: 'https://www.ok.ru/RSVRU',
            fb: 'https://www.facebook.com/anorsv',
            tg: 'https://t.me/stranavozmojnostey',
            inst: 'https://instagram.com/rsv.ru',
            youtube: 'https://www.youtube.com/channel/UCJPc1Fjh9C8tPUo5qBEErMw',
            rutube: 'https://rutube.ru/channel/23486710/',
            yappy: 'https://yappy.media/profile/2e84754f849c4f488ff9e1fe870cb17d',
            tenchat: 'https://tenchat.ru/rsvru',
            dzen: 'https://dzen.ru/rossiya_strana_vozmozhnostej',
        },
        copyLinkStatus: {
            shown: false,
            success: false,
        },
    }),

    methods: {
        copyLinkHandler() {
            this.$set(this.copyLinkStatus, 'shown', true);
            this.$set(this.copyLinkStatus, 'success', false);
            this.$nextTick(() => {
                this.$refs.copyLinkInput.select();
                try {
                    var success = document.execCommand('copy');
                    this.$set(this.copyLinkStatus, 'success', true);
                    setTimeout(() => {
                        this.$set(this.copyLinkStatus, 'shown', false);
                    }, 500);
                } catch (err) {}
            });
        },
        click(provider) {
            switch (this.mode) {
                case 'link':
                    window.open(this.links[provider], '_blank');
                    break;
                case 'share':
                    this.share(provider);
                    break;
                default:
                    this.$emit('click', provider);
                    break;
            }
        },
        share(provider) {
            let open = null;
            let url = window.location.href;
            switch (provider) {
                case 'link':
                    this.copyLinkHandler();
                    break;
                case 'vk':
                    open = `http://vk.com/share.php?url=${url}`;
                    break;
                case 'ok':
                    open = `https://connect.ok.ru/offer?url=${url}`;
                    break;
                case 'tg':
                    open = `https://telegram.me/share/url?url=${url}`;
                    break;
                case 'fb':
                    open = `https://www.facebook.com/sharer/sharer.php?href=${url}`;
                    break;
                case 'rutube':
                    open = 'https://rutube.ru/channel/23486710/';
                    break;
                case 'yappy':
                    open = 'https://yappy.media/profile/2e84754f849c4f488ff9e1fe870cb17d';
                    break;
                case 'dzen':
                    open = 'https://dzen.ru/rossiya_strana_vozmozhnostej';
                    break;
                case 'tenchat':
                    open = 'https://tenchat.ru/rsvru';
                    break;
            }
            if (open) {
                window.open(open, '', 'width=400,height=300');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/rem';
@import '../../styles/mrem';
@import '../../styles/variables';
/*activate checkbox regExp in finder of phpStorm*/
/*find      {: ([0-9]*)px}*/
/*replace   {: rem($1);}*/

.social-links {
    display: flex;
    flex-direction: row;
    list-style: none;
    padding: 0;
    justify-content: space-between;

    &-item {
        margin-right: rem(16);

        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;

        &:last-of-type {
            margin-right: 0;
        }

        @include on-mobile {
            margin-right: mrem(10);
            width: mrem(40);
            height: mrem(40);
            border-radius: 100%;
            overflow: hidden;
        }

        svg {
            width: 100%;
            height: auto;
        }
    }

    &__icon {
        margin-right: mrem(10);
        color: inherit;

        width: mrem(29);
        height: mrem(24);

        @include on-desktop {
            margin-right: rem(10);
            width: rem(32);
            height: rem(32);
            cursor: pointer;

            &:hover {
                path {
                    fill: #fff;
                }
            }
        }

        circle {
            transition: all ease-in 0.1s;
        }

        &_share:hover {
            circle {
                fill: #00e5bc;
            }
        }

        &_yappy:hover {
            circle {
                fill: #00e5bc;
            }
            .black-fill {
                fill: #000;
            }
        }

        &_dzen:hover {
            circle {
                fill: #251f45;
            }
        }

        &_rt:hover {
            circle {
                fill: #100943;
            }
            .rutube-top-circle {
                fill: #ed143b;
            }
        }

        &_yt:hover {
            circle {
                fill: #c4302b;
            }
        }

        &_tg:hover {
            circle {
                fill: #039be5;
            }
        }

        &_inst:hover {
            circle {
                fill: #c536a4;
            }
        }

        &_ok:hover {
            circle {
                fill: #ed812b;
            }
        }

        &_vk:hover {
            circle {
                fill: #0077ff;
            }
        }

        &_tenchat:hover {
            circle {
                fill: #fc3234;
            }
        }
    }

    &__button {
        &_white-blue {
            circle {
                fill: #fff;
            }

            path {
                fill: #93c2e8;
            }
        }

        &_contacts-card {
            circle {
                fill: $color-main-primary;
            }

            path {
                fill: #fff;
            }
        }
    }

    &--header {
        .social-links {
            &-item {
                width: mrem(40);
                height: mrem(40);
                @include on-desktop {
                    margin-right: rem(10);
                    width: rem(40);
                    height: rem(40);
                }
                &:last-of-type {
                    margin-right: 0;
                }
            }
            &__icon {
                margin: 0;
                width: mrem(34);
                height: mrem(34);
                border-radius: 50%;
                @include on-desktop {
                    width: rem(34);
                    height: rem(34);
                    border-radius: 50%;
                }
            }
        }
    }

    &--footer {
        margin-top: mrem(10);

        @include on-desktop {
            margin-top: rem(10);
            margin-bottom: rem(10);
        }

        .social-links {
            &-item {
                width: mrem(34);
                height: mrem(34);
                margin-right: mrem(10);

                @include on-desktop {
                    width: rem(34);
                    height: rem(34);
                    margin-right: rem(16);
                }
            }
            &__icon {
                width: mrem(34);
                height: mrem(34);
                margin: 0;

                @include on-desktop {
                    width: rem(34);
                    height: rem(34);
                }

                circle,
                .back {
                    fill: rgba(255, 255, 255, 0.4);
                }

                path {
                    fill: rgba(70, 99, 171, 1);
                }

                &:hover {
                    path {
                        fill: rgba(255, 255, 255, 0.8);
                    }
                }
            }
        }
    }

    &--sidebar {
        margin: 0 0 mrem(24);
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: mrem(18);

        @include on-desktop {
            margin: 0 0 rem(24);
            column-gap: 0;
            row-gap: rem(8);
            column-gap: rem(6);
        }
        .social-links {
            &-item {
                margin-right: 0;
                margin-bottom: 0;
                @include on-desktop {
                    margin-right: 0;
                    margin-bottom: 0;
                    width: rem(36);
                    height: rem(36);
                }
            }
            &__icon {
                width: mrem(40);
                height: mrem(40);
                margin-right: 0;
                @include on-desktop {
                    width: rem(30);
                    height: rem(30);
                }
                circle,
                .back {
                    fill: rgba(255, 255, 255, 0.4);
                }
                &:hover {
                    circle,
                    .back {
                        fill: rgba(255, 255, 255, 0.8);
                    }
                    .black-fill {
                        fill: #4663ab;
                    }
                    .rutube-top-circle {
                        fill: #4663ab;
                    }
                }
            }
        }
    }
}
.btn {
    width: mrem(32) !important;
    height: mrem(32) !important;

    @include on-desktop {
        width: rem(32) !important;
        height: rem(32) !important;
    }
}

.btn-copy {
    border-radius: 50%;

    &:hover {
        background-color: $color-main-primary;
    }
}

.bubble-wrapper {
    @include on-desktop {
        position: relative;
    }
}

.bubble {
    position: absolute;
    width: rem(280);
    height: rem(40);
    left: 0;
    display: flex;
    background-color: #2a2626;
    opacity: 0.9;
    box-shadow: 0px rem(2) rem(8) rgba(155, 161, 166, 0.23626);
    border-radius: rem(4);
    padding: 0 rem(16);
    justify-content: center;
    align-items: center;

    @include on-mobile {
        border-radius: mrem(4);
        min-height: mrem(40);
        min-width: mrem(40);
        font-size: mrem(16);
        line-height: mrem(20);
        width: 80rem;
        height: mrem(40);
        left: mrem(40);
        right: mrem(40);
        bottom: mrem(80);
    }

    input {
        font-size: 1rem;
        height: rem(40);
    }

    span {
        color: white;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
}
</style>
